import React from "react";
import Typography from "@material-ui/core/Typography";

const TitlePage = ({title, menuIcon}) => {
    return (
        <table className="title-page-presval">
            <tr>
                <td valign={"bottom"} align='left'>
                    <i className={"material-icons"}>{menuIcon}</i>
                </td>
                <td valign={"middle"} align='left'>
                    <Typography variant="h5" component="h3" style={{fontWeight: "bolder"}}>
                        {title}
                    </Typography>
                </td>
            </tr>
        </table>
    )
};

export default TitlePage;